export enum TradeStatus {
  Pending = 'pending',
  InProgress = 'inProgress',
  Completed = 'completed',
}

export enum TradeDirection {
  Long = 'long',
  Short = 'short',
  StrongShort = 'strongShort',
  Neutral = 'neutral',
  StrongLong = 'strongLong',
}

export enum TradeSentiment {
  Long = 'long',
  Short = 'short',
  StrongShort = 'strongShort',
  Neutral = 'neutral',
  StrongLong = 'strongLong',
}

export interface TradeMetrics {
  positionsLong: number | null;
  positionsShort: number | null;
  volumeLong: number | null;
  volumeShort: number | null;
  metric3Long: number | null;
  metric3Short: number | null;
}

export interface TradeDetailedData {
  symbolName: string; // e.g., "Bitcoin to US Dollar"
  category: 'Futures' | 'Forex' | 'Crypto' | 'Stocks' | 'Indices';
  currentPrice: number;
  priceChange: number;
  priceChangePercent: number;
  currency: string;
  assetSentimentPercent: number;
  marketSentimentPercent: number;
  high24h: number;
  low24h: number;
  marketCapFormatted: string;
  supplyFormatted: string;
}

export interface TradeRowData {
  id: string;
  symbol: string;
  abbreviation: string;
  direction: TradeDirection;
  sentiment: TradeSentiment;
  status: TradeStatus;
  isActive: boolean;
  isPinned: boolean;
  metrics: TradeMetrics;
  detailedData?: TradeDetailedData;
}

export interface CommunityTradesTableProps {
  data?: TradeRowData[];
  isLoading?: boolean;
  isSearching?: boolean;
  variant?: 'default' | 'alternate';
  activeSymbol?: string | null;
  pinnedSymbols?: string[];
  activeAssetData?: TradeDetailedData;
  isActiveAssetLoading?: boolean;
  onSymbolSelect?: (symbol: string | null) => void;
  onPinToggle?: (row: TradeRowData) => void;
  onSearchChange?: (search: string) => void;
}

export interface TradeRowProps {
  row: TradeRowData;
  isDetailLoading?: boolean;
  onPinToggle?: (row: TradeRowData) => void;
  onRowClick?: (row: TradeRowData) => void;
}

export interface StatusIconProps {
  status: TradeStatus;
  abbreviation: string;
  isActive?: boolean;
}

export interface TableHeaderRowProps {
  variant?: 'default' | 'alternate';
}
